export default __webpack_public_path__ + "../img/gulfstreamnews.png";